export default "__VITE_ASSET__DMt5TTZq__"